import { forwardRef, type InputHTMLAttributes } from "react";

type PennCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const PennCheckbox = forwardRef<HTMLInputElement, PennCheckboxProps>(
  ({ className = "", ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      {...props}
      className={`w-4 h-4 accent-penn-500 cursor-pointer ${className}`.trim()}
    />
  )
);

PennCheckbox.displayName = "PennCheckbox";
